var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posts-list",class:{'--grid': _vm.isGrid }},[_vm._l((_vm.posts),function(post){return [_c(_vm.postComponent,{key:post.id,tag:"component",attrs:{"post":post}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }